import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-managment',
  templateUrl: './user-managment.component.html',
})
export class UserManagmentComponent implements OnInit {
  selectedIndex = 0;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((qp) => {
      this.selectedIndex = qp.tabindex || 0;
    });
  }
}
